import LogoBrofer from '../../../uploads/Photos/Home-Screen/LogoClouds/logo_Brofer.png' 
// import LogoVortice from '../../../uploads/Photos/Home-Screen/LogoClouds/logo-Vortice.png' 
// import LogoVorticeIndustrial from '../../../uploads/Photos/Home-Screen/LogoClouds/logo-vortice-industrial.jpg' 
import LogoUponor from '../../../uploads/Photos/Home-Screen/LogoClouds/logo-uponor.png'
import LogoSiemens from '../../../uploads/Photos/Home-Screen/LogoClouds/siemens-logo.png'
import LogoMelcohit from '../../../uploads/Photos/Home-Screen/LogoClouds/logo-MelcoHIT.png'

export default function Example() {
  return (
    <div className="bg-white py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <h2 className="text-center text-lg/8 font-semibold text-gray-900">
          Доверба од најиновативните тимови во светот
        </h2>
        <div className="mx-auto mt-10 grid max-w-lg grid-cols-4 items-center gap-x-10 gap-y-10 sm:max-w-xl sm:grid-cols-6 sm:gap-x-10 lg:mx-0 lg:max-w-none lg:grid-cols-4">
          <img
            alt="logo_Brofer"
            src={LogoBrofer}
            width={158}
            height={48}
            className="col-span-2 max-h-12 w-full object-contain lg:col-span-1"
          />
          <img
            alt="logo-Siemens"
            src={LogoSiemens}
            width={158}
            height={48}
            className="col-span-2 max-h-12 w-full object-contain lg:col-span-1"
          />
          <img
            alt="logo-uponor"
            src={LogoUponor}
            width={140}
            height={35}
            className="col-span-2 max-h-12 w-full object-contain sm:col-start-2 lg:col-span-1"
          />
          <img
            alt="logo-melcohit"
            src={LogoMelcohit}
            width={158}
            height={48}
            className="col-span-2 col-start-2 max-h-12 w-full object-contain sm:col-start-auto lg:col-span-1"
          />
        </div>
      </div>
    </div>
  )
}
